import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as QueueJobActions from './queue-job.actions';
import { QueueJob } from './queue-job.model';
import { Guid } from '../../../shared';

export const queueJobFeatureKey = 'QueueJob';

export interface State extends EntityState<QueueJob> {
    // additional entities state properties
}

export const adapter: EntityAdapter<any> = createEntityAdapter<QueueJob>({
    selectId: () => `${Math.random()}`
});

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

export const QueueJobReducer = createReducer(
    initialState,
    on(QueueJobActions.addQueueJob, (state, action) =>
        adapter.addOne(action.QueueJob, state)
    ),
    on(QueueJobActions.upsertQueueJob, (state, action) =>
        adapter.upsertOne(action.QueueJob, state)
    ),
    on(QueueJobActions.addQueueJobs, (state, action) =>
        adapter.addMany(action.QueueJobs, state)
    ),
    on(QueueJobActions.upsertQueueJobs, (state, action) =>
        adapter.upsertMany(action.QueueJobs, state)
    ),
    on(QueueJobActions.updateQueueJob, (state, action) =>
        adapter.updateOne(action.QueueJob, state)
    ),
    on(QueueJobActions.updateQueueJobs, (state, action) =>
        adapter.updateMany(action.QueueJobs, state)
    ),
    on(QueueJobActions.deleteQueueJob, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(QueueJobActions.deleteQueueJobs, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(QueueJobActions.loadQueueJobs, (state, action) =>
        adapter.setAll(action.QueueJobs, state)
    ),
    on(QueueJobActions.clearQueueJobs, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return QueueJobReducer(state, action);
}

export const selectQueueJobState = createFeatureSelector<State>(
    queueJobFeatureKey
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(selectQueueJobState);
